<template>
  <div
    class="payment-info bg-white border border-border rounded-md lg:mb-5 mb-4"
    v-if="
      (state.show_cc_label || state.show_payroll_label || state.show_payroll_enrollment_label || state.show_payment) &&
      state.bundled_group.filter((item) => item.select_plan).length > 0 &&
      !state.disp_err_msg
    "
  >
    <div
      class="flex w-full border-b border-border !m-0 p-4 gap-[8px] items-center"
    >
      <span class="number-badge">
        <span v-if="state.opt_type != 'general' && state.opt_type != 'SEIU721'"
          >4</span
        >
        <span v-if="state.opt_type == 'general' || state.opt_type == 'SEIU721'"
          >5</span
        >
      </span>
      <h6 class="card-title !m-0">Payment / Credit Card Information</h6>
    </div>

    <div
      class="p-4"
      v-if="
        state.disp_enroll_section &&
        state.show_payment &&
        state.bundled_group.filter((item) => item.select_plan).length > 0 &&
        !state.disp_err_msg
      "
    >
      <h3 class="text-lg font-semibold mb-4">Payment Option</h3>
      <div class="space-y-4">
        <label class="flex items-center">
          <input
            type="radio"
            name="payment_method"
            value="CC"
            v-model="paymentMethod"
            @change="getEffDate"
            class="form-radio text-indigo-600 focus:ring-indigo-500"
          />
          <span class="ml-2">I will pay using credit card.</span>
        </label>
        <label class="flex items-center">
          <input
            type="radio"
            name="payment_method"
            value="Payroll"
            v-model="paymentMethod"
            @change="getEffDate"
            class="form-radio text-indigo-600 focus:ring-indigo-500"
          />
          <span class="ml-2"
            >I will pay via payroll/settlement deductions.</span
          >
        </label>
      </div>
    </div>
    <!-- <div class="p-4"  >
          <div class="space-y-4">
            
            <label class="flex items-center bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-3 rounded dark:bg-gray-700 dark:text-blue-400 border border-blue-400" v-if="state.show_cc_label">
              <img src="@/assets/images/info.svg" alt="info">

              <span class="ml-2">I will pay using credit card.</span>
            </label>
            <label class="flex items-center bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-3 rounded dark:bg-gray-700 dark:text-blue-400 border border-blue-400" v-if="state.show_payroll_label || state.show_payroll_enrollment_label">
              <img src="@/assets/images/info.svg" alt="info">

              <span class="ml-2"
                >I will pay via payroll/settlement deductions.</span
              >
            </label>
          </div>
        </div> -->
    <div
      class="p-4"
      v-if="
        state.payment_method != 'Payroll' &&
        state.enroll_option != 'affilliated'
      "
    >
      <div class="form-group mb-4">
        <label id="creditCardHolder-label" for="creditCardHolder" class="field-label font-normal text-mute text-sm mb-2 inline-block"
          >Card Holder Name<span class="required-asterisk text-error">*</span></label
        >
        <input
          id="creditCardHolder"
          type="text"
          placeholder="Enter Card Holder Name"
          class="form"
          v-model="localForm.creditCardHolder"
          @blur="updateParent('creditCardHolder')"
        />
        <small
          v-if="validation.user_form.creditCardHolder.$error"
          class="text-error text-xs"
        >
          Card Holder's Name is required.
        </small>
      </div>
      <div class="form-group mb-4">
        <label id="cc_type-label" for="cc_type" class="field-label font-normal text-mute text-sm mb-2 inline-block">
          Card Type <span class="required-asterisk text-error">*</span>
        </label>
        <select
          id="cc_type"
          class="form-mask"
          @change="updateParent('cc_type')"
          v-model="localForm.cc_type"
        >
          <option value="visa">Visa, MasterCard, Discover</option>
          <option value="amex">Amex</option>
        </select>
        <small
          v-if="validation.user_form.cc_type.$error"
          class="text-error text-xs"
        >
          Card Type is required.
        </small>
      </div>
      <div class="form-group mb-4">
        <label id="cc-label" for="cc" class="field-label font-normal text-mute text-sm mb-2 inline-block"
          >Card Number<span class="required-asterisk text-error">*</span></label
        >
        <div class="relative">
          <InputMask
            id="cc"
            autocomplete="cc-number"
            :mask="
              localForm.cc_type != 'amex'
                ? '9999-9999-9999-9999'
                : '9999-999999-99999'
            "
            placeholder="Enter Card Number"
            class="form-mask"
            autoClear="false"
            :unmask="false"
            :pt="{
              input: {
                id: 'cc',
                'aria-labelledby': 'cc-label'
              }
            }"
            :inputProps="{
              inputmode: 'numeric',
              autocomplete: 'cc-number',
            }"
            inputmode="numeric"
            type="tel"
            v-model="localForm.cc"
            @blur="updateParent('cc')"
          />

          <img
            v-if="localForm.cc_type != 'amex'"
            src="@/assets/images/visa.svg"
            alt="visa"
            class="absolute top-2/4 right-[15px] -translate-y-1/2"
          />
          <img
            v-if="localForm.cc_type == 'amex'"
            src="@/assets/images/amex.svg"
            alt="visa"
            class="absolute top-2/4 right-[15px] -translate-y-1/2 h-8"
          />
        </div>
        <small v-if="validation.user_form.cc.$error" class="text-error text-xs">
          Card Number is required.
        </small>
      </div>
      <div class="grid grid-cols-1 xl:grid-cols-2 gap-4">
        <div>
          <label id="exp_month-label" for="exp_month" class="field-label font-normal text-mute text-sm mb-2 inline-block"
            >Expiration Date<span class="required-asterisk text-error">*</span></label
          >
          <InputMask
            id="exp_month"
            mask="99/9999"
            placeholder="MM/YYYY"
            class="form-mask"
            autoClear="false"
            :unmask="false"
            :pt="{
              input: {
                id: 'exp_month',
                'aria-labelledby': 'exp_month-label'
              }
            }"
            :inputProps="{
              inputmode: 'numeric',
              autocomplete: 'cc-exp',
            }"
            inputmode="numeric"
            type="tel"
            v-model="localForm.exp_month"
            @blur="updateParent('exp_month')"
          />

          <small
            v-if="
              validation.user_form.exp_month.required.$invalid &&
              validation.user_form.exp_month.$error
            "
            class="text-error text-xs"
          >
            Expiration Date is required.
          </small>
          <small
            v-if="
              validation.user_form.exp_month.validateExpiryMonth.$invalid &&
              !validation.user_form.exp_month.required.$invalid &&
              validation.user_form.exp_month.$error
            "
            class="text-error text-xs"
          >
            Please enter valid date
          </small>
        </div>
        <div>
          <label id="ccv-label" for="ccv" class="field-label font-normal text-mute text-sm mb-2 inline-block"
            >Security Code (CCV)<span class="required-asterisk text-error">*</span></label
          >
          <InputMask
            id="ccv"
            :mask="localForm.cc_type != 'amex' ? '999' : '9999'"
            placeholder="Enter Security Code (CCV)"
            class="form-mask"
            autoClear="false"
            :unmask="false"
            :pt="{
              input: {
                id: 'ccv',
                'aria-labelledby': 'ccv-label'
              }
            }"
            :inputProps="{
              inputmode: 'numeric',
              autocomplete: 'cc-csc',
            }"
            v-model="localForm.ccv"
            inputmode="numeric"
            type="tel"
            @blur="updateParent('ccv')"
          />

          <small
            v-if="validation.user_form.ccv.$error"
            class="text-error text-xs"
          >
            CCV is required.
          </small>
        </div>
        <div>
          <label id="billingZip-label" for="billingZip" class="field-label font-normal text-mute text-sm mb-2 inline-block"
            >Billing Zip Code<span class="required-asterisk text-error" 
            v-if="state.payment_method != 'Payroll' && state.enroll_option != 'affiliated'">*</span></label
          >
          <InputMask
          id="billingZip"
          autoClear="false"
            :unmask="false"
            :pt="{
              input: {
                id: 'billingZip',
                'aria-labelledby': 'billingZip-label'
              }
            }"
            :inputProps="{
              inputmode: 'numeric',
              autocomplete: 'postal-code',
            }"
            mask="99999"
            placeholder="Enter Billing Zip Code"
            class="form-mask"
            inputmode="numeric"
            type="tel"
            v-model="localForm.billingZip"
            @blur="updateParent('billingZip')"
          />
            <small
            v-if="validation.user_form.billingZip.$error"
            class="text-error text-xs"
          >
            Billing Zip is required.
          </small>
        </div>
      </div>
    </div>

    <!-- Payroll Details -->
    <div class="p-4" v-if="state.payment_method === 'Payroll'">
      <div class="bg-blue-50 border border-blue-200 rounded-md p-4 space-y-2">
        <div class="flex items-center gap-2 mb-3">
          <img src="@/assets/images/info.svg" alt="info" height="18px" width="18px" />
          <span class="font-semibold text-sm text-blackPrimary">Payroll / Settlement Deduction Details</span>
        </div>
        <p class="text-sm text-mute">
          <span class="font-medium">Effective Date:</span>
          {{ state.eff_date ? new Date(state.eff_date).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }) : '—' }}
        </p>
        <p class="text-sm text-mute" v-if="selectedPlan">
          <span class="font-medium">Monthly Deduction:</span>
          ${{ selectedPlan.total_monthly_prem }}
        </p>
        <p class="text-sm text-mute">
          Your payroll/settlement deduction is based on the deduction frequency of your company.
        </p>
        <p class="text-sm text-mute" v-if="state.company && state.company.company_name">
          Payroll/settlement deduction authorization will be submitted to <span class="font-medium">{{ state.company.company_name }}</span>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import InputMask from "primevue/inputmask"; // Validation mask
export default {
  name: "PaymentInfoSection",
  props: {
    user_form: {
      type: Object,
    },
    state: {
      type: Object,
    },
    validation: {
      type: Object,
    },
  },
  components: {
    InputMask,
  },
  data() {
    return {
      localForm: this.user_form, // Create a local copy of the form
      validationState: {},
      paymentMethod: null,
    };
  },
  computed: {
    selectedPlan() {
      return this.state.bundled_group?.find(item => item.select_plan) || null;
    },
  },
  methods: {
    getEffDate() {
      this.$emit("updateState", {
        key: "payment_method",
        value: this.paymentMethod,
      });
      this.$emit("getEffDate");
    },
    updateParent(field) {
      // Emit the updated value to the parent
      this.$emit("update:user_form", {
        ...this.localForm,
        [field]: this.localForm[field],
      });
      if (this.validation.user_form[field]?.$touch) {
        this.validation.user_form[field].$touch();
      }
      const hasError = this.validation.user_form[field]?.$error || false;
      this.validationState[field] = hasError;
    },
  },
};
</script>

<style scoped>
/* WCAG: increase contrast for labels/errors in this section only */
.payment-info .field-label {
  color: #595959 !important;
}

.payment-info .required-asterisk {
  color: #b00020 !important;
}

.payment-info :deep(small.text-error) {
  color: #b00020 !important;
}
</style>
